/* eslint-disable no-undef */
import React from 'react';
import css from 'styled-jsx/css';
import { Link, IconCPRA } from '@lmig/lmds-react';
import getConfig from 'next/config';
import PropTypes from 'prop-types';

const {
  publicRuntimeConfig: { privacy },
} = getConfig();


const { className: iconClass, styles: iconStyles } = css.resolve`
@import './global-styles/tokens';
* {
  margin-right: 1rem;
}
`;

const CCPAFooterLink = ({ iconColor = 'inverse',
  linkBackgroundColor = 'blue',
  className = '', }) => {
  const { className: linkClass, styles: linkStyles } = css.resolve`
    @import './global-styles/tokens';
    * {
      padding-top: 2px;
    }
  `;

  return (
    <div className={className}>
      <span>
        <IconCPRA className={iconClass} color={iconColor} />
        <Link href={privacy.url} target="_blank" onBackground={linkBackgroundColor} className={linkClass}>Your California Privacy Choices</Link>
      </span>
      <span className="footerPipe"> | </span>
      <Link onClick={() => {
        if (utag != null) {
          utag.gdpr.showDoNotSellPrompt();
        }
      }} onBackground={linkBackgroundColor} className={linkClass}>Do Not Sell or Share My Personal Information (CA Residents Only)</Link>
      {linkStyles}
      {iconStyles}
      <style jsx>{`
          @import './global-styles/tokens';
          .footerPipe {
            padding-top: .25rem;
            line-height: 2rem;
            margin-left: 0.5rem;
            margin-right: 0.5rem;
            @media (min-width: $lm-breakpoint-md-min) {
              line-height: inherit;
            }
          }
        `}</style>
    </div>
  );
};

CCPAFooterLink.propTypes = {
  className: PropTypes.string,
  iconColor: PropTypes.string,
  linkBackgroundColor: PropTypes.string,
};

export default CCPAFooterLink;
